export const getPaymentDifferenceType = (
  signedBankLineAmount: number,
  difference: number,
): 'overpayment' | 'underpayment' => {
  const itemsTotal = signedBankLineAmount - difference
  const isPositive = signedBankLineAmount > 0 || itemsTotal > 0
  if (isPositive) {
    return difference > 0 ? 'overpayment' : 'underpayment'
  }
  return difference > 0 ? 'underpayment' : 'overpayment'
}
